// extracted by mini-css-extract-plugin
module.exports = {"primary":"#b91c45","secondary":"#444b53","progress":"#e489a2","hover":"#e0e0e1"};